import dynamic from "next/dynamic";
const TagsGridComponent = dynamic(()=>import("./tags-grid-component"));
import TagsGridConfig from "./tags-grid-config";
import TagsGridAdvancedConfig from "./tags-grid-advanced-config";
export default {
    TagsGridComponent,
    TagsGridConfig,
    TagsGridAdvancedConfig
};
